import { useState, useEffect } from 'react';

export interface ClientInfo {
  id: string;
  name: string;
  businessArea: string;
}

// Mock implementation of client data - replace with actual API call in production
const fetchActiveClient = (): Promise<ClientInfo> => {
  return new Promise((resolve) => {
    // Simulate API delay
    setTimeout(() => {
      resolve({
        id: 'CLIENT12345',
        name: 'UK Private Bank',
        businessArea: 'Private Banking'
      });
    }, 500);
  });
};

export const useActiveClient = () => {
  const [activeClient, setActiveClient] = useState<ClientInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getActiveClient = async () => {
      try {
        setLoading(true);
        const client = await fetchActiveClient();
        setActiveClient(client);
        setError(null);
      } catch (err) {
        console.error('Error fetching active client:', err);
        setError('Failed to load client information. Please try again later.');
        setActiveClient(null);
      } finally {
        setLoading(false);
      }
    };

    getActiveClient();
  }, []);

  const updateClient = async (clientId: string) => {
    try {
      setLoading(true);
      // In a real app, this would fetch client details based on the ID
      // For now, mock a client switch with a delay
      await new Promise(resolve => setTimeout(resolve, 500));
      
      setActiveClient({
        id: clientId,
        name: `Client ${clientId}`,
        businessArea: 'Private Banking'
      });
      setError(null);
    } catch (err) {
      console.error('Error updating client:', err);
      setError('Failed to update client. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return { activeClient, loading, error, updateClient };
};

export default useActiveClient; 